import { render, staticRenderFns } from "./FilterTreatmentProducts.vue?vue&type=template&id=6a661f40&scoped=true&lang=pug&"
import script from "./FilterTreatmentProducts.vue?vue&type=script&lang=js&"
export * from "./FilterTreatmentProducts.vue?vue&type=script&lang=js&"
import style0 from "./FilterTreatmentProducts.vue?vue&type=style&index=0&id=6a661f40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a661f40",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDivider,VIcon,VMenu,VSkeletonLoader,VSpacer,VTextField})
